import { AltDivider, Divider, Fee, Fees, Reservation, ReservationProps, Room, RoomProps } from './components'

export type FeeProps = {
  label?: string
  description?: string
  fee?: string
  discountedFee?: string
  discount?: string
}

export interface OrCheckoutSummaryProps {
  room: RoomProps
  reservation: ReservationProps
  fees?: FeeProps[]
  subTotal?: string
  taxes?: string
  taxPercentage?: string
  total?: string
  simple?: boolean
  paid?: boolean
  className?: string
}

export const OrCheckoutSummary = ({
  fees,
  reservation,
  room,
  subTotal,
  taxes,
  taxPercentage,
  total,
  simple,
  paid,
  className = '',
}: OrCheckoutSummaryProps) => (
  <section className={`lg:pt-12 lg:px-10 border-l-1 border-neutrals-300 flex-1 ${className}`}>
    <Room {...room} />
    <AltDivider />
    <div className="px-4 lg:px-0">
      <Reservation {...reservation} simple={simple} />

      {!simple && (
        <>
          <Divider />
          {fees && <Fees fees={fees} />}
          <Divider />
          <Fee label="Subtotal" fee={subTotal} className="mb-2 lg:mb-4" />
          <Fee label="Sales Tax" fee={taxes} description={taxPercentage} className="mb-4 lg:mb-6" />

          <div className="flex justify-between font-bold text-neutrals-900 leading-1.5 lg:text-20">
            <p>Total {paid ? 'Paid' : 'Due'}</p>
            <p>{total}</p>
          </div>
        </>
      )}
    </div>
  </section>
)

export { Discount, formatDateDetails } from './components'
